export enum EXERCISE_MODE {
  'VIEW' = 'view',
  'EDIT' = 'edit',
}

export enum EXERCISE_FIELD_NAMES {
  'RATING' = 'rating',
  'TARGET_MUSCLES' = 'targetMuscles',
  'USER_ID' = 'userId',
  'ADMIN' = 'admin',
}
